import firebase from "firebase";
import dayjs from "dayjs";
import {fetchIndex} from "../../../../firestore/reports";
import {getCurrentMonth} from "../../../../utils/date";

export const copyReports = {
  data() {
    return {
      copyData: {
        pickData: null,
        dialogVisible: false,
        loading: false
      }
    }
  },
  methods: {
    async copyChild(id, form) {
      const report = await this.getReportById(id);

      const response = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .add({
          ...report,
          ...form,
          approveUser: null,
        })

      return response.id
    },
    async doCopy() {
      this.copyData = {
        ... this.copyData,
        approve: false,
        approveUser: null,
        loading: true,
      }

      const datetime = dayjs(this.copyData.pickData).format();
      const dateunix = dayjs(dayjs(datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix();

      const index = await fetchIndex(this.$store.state.project.id);
      const response = await this.getReportById(this.$route.params.id);

      const report = {
        ...response,
        approve: false,
        approveUser: null,
        index,
        dateunix,
        datetime,
      }

      const docRef = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports').doc();

      if (report.reportPROF) {
        report.PROF.index = report.index
        report.reportPROF = await this.copyChild(report.reportPROF, {
          from: docRef.id,
          index: report.index,
          approve: false,
          approveUser: null,
          dateunix,
          datetime,
        });
        report.index = report.index + 1
      }

      if (report.reportTECH) {
        report.TECH.index = report.index
        report.reportTECH = await this.copyChild(report.reportTECH, {
          from: docRef.id,
          index: report.index,
          approve: false,
          approveUser: null,
          dateunix,
          datetime,
        });
        report.index = report.index + 1
      }



      let batch = firebase.firestore().batch();
      batch.set(docRef, {...report, approve: false, approveUser: null});
      await batch.commit()

      this.$notify.success({
        title: 'Отчет успешно скопирован',
        offset: 60,
        message: 'Переход в новый отчет',
      });

      setTimeout(() => {
        this.$router.push(`/dashboard/reports/create/${docRef.id}/${this.$route.params.type}`);
      }, 500)

      this.copyData = {
        pickData: null,
        dialogVisible: false,
        loading: false
      }
    },
    async getReportById(id) {
      const report = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(id).get()

      return report.data()
    },
    copyReport() {
      let copyData = {}
      let pickData = new Date()

      if (this.$store.state.project.plan && this.$store.state.project.plan.name) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix()
        const unixDateEnd = dayjs(year  + '-' + month  + '-' + dayjs(unixDateStart * 1000).daysInMonth() + ' 00:00:00').unix()


        if(!dayjs().isBetween(dayjs(unixDateStart * 1000).format(), dayjs(unixDateEnd * 1000).format(), null, '[]')) {
          if (unixDateEnd > dayjs().unix()) {
            pickData = new Date(dayjs(unixDateStart * 1000).format())
          }

          if (unixDateStart < dayjs().unix()) {
            pickData = new Date(dayjs(unixDateEnd * 1000).format())
          }
        }
      }

      this.copyData = {
        ...this.copyData,
        approve: false,
        approveUser: null,
        pickData,
        dialogVisible: true
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/Reports/mixins/copyReports.js